export class DesktopNotification {
  constructor(
    readonly title: string,
    readonly body: string,
  ) {}
}
